var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nutrition-template',{attrs:{"processed-food-intake":_vm.processedFoodIntake,"anti-oxidant-intake":_vm.antiOxidantIntake,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }